var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('Hero'),_vm._v(" "),_c('Statement'),_vm._v(" "),_c('Features'),_vm._v(" "),_c('Connect'),_vm._v(" "),_c('JoinUs')],1)}
var staticRenderFns = []

export { render, staticRenderFns }